import { useRouter } from "next/router";
import { useMemo } from "react";

interface Localization {
  language: string;
}

interface CollectionItem<V> {
  localizations: V[];
}

const useFilterCollectionByLang = <T extends CollectionItem<V>, V extends Localization>(
  collection: T[] = [],
) => {
  const { locale } = useRouter();

  const filteredCollection = useMemo(
    () =>
      collection.map((item) => ({
        ...item,
        localization: item.localizations.find((localization) => localization.language === locale),
      })),
    [locale],
  );

  return { filteredCollection };
};

export default useFilterCollectionByLang;
